import { render, staticRenderFns } from "./OnlineWaTemplateParser.vue?vue&type=template&id=230b97a2&scoped=true&"
import script from "./OnlineWaTemplateParser.vue?vue&type=script&lang=js&"
export * from "./OnlineWaTemplateParser.vue?vue&type=script&lang=js&"
import style0 from "./OnlineWaTemplateParser.vue?vue&type=style&index=0&id=230b97a2&prod&lang=scss&scoped=true&"
import style1 from "./OnlineWaTemplateParser.vue?vue&type=style&index=1&id=230b97a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230b97a2",
  null
  
)

export default component.exports